// @ts-nocheck
import authService from '../authService';
// 🟡 CHECK-IN PREVIEW (v6.460): πριν την ημέρα check-in τα save σελίδων 1-3 γίνονται no-op.
import { isCheckinPreview } from '../utils/previewMode';
// Production API base URL - always use this, even when running locally
const API_BASE = 'https://yachtmanagementsuite.com/api';
const API_URL = API_BASE;
const PAGE1_API_URL = `${API_BASE}/page1.php`;

// 🔐 ΦΑΣΗ 2 (23/10/2026) — Customer token: ο πελάτης στέλνει X-Customer-Token σε κάθε
// κλήση ώστε τα scoped endpoints (bookings κ.λπ.) να του δίνουν ΜΟΝΟ τον δικό του ναύλο.
// Υπάρχει ΜΟΝΟ στον πελάτη (sessionStorage yms_cust_token)· το προσωπικό δεν το έχει.
export function custToken(): string {
  try { return sessionStorage.getItem('yms_cust_token') || ''; } catch (e) { return ''; }
}
// Προσθέτει το σωστό credential header στις κλήσεις: X-Customer-Token για πελάτη,
// αλλιώς X-Employee-Code για προσωπικό (ώστε τα scoped endpoints να μην εξαρτώνται
// ΜΟΝΟ από το cookie yms_code). Αν κανένα → επιστρέφει ως έχει (ανώνυμο → 401 από gate).
export function withCust(h: Record<string, string> = {}): Record<string, string> {
  const t = custToken();
  if (t) return { ...h, 'X-Customer-Token': t };
  try {
    const u = JSON.parse(sessionStorage.getItem('auth_current_user') || 'null');
    if (u && u.code) return { ...h, 'X-Employee-Code': u.code };
  } catch (e) { /* ignore */ }
  return h;
}

// 🔥 FIX 17: Vessel ID to Name mapping for API calls
const VESSEL_NAMES: { [key: number]: string } = {
  1: 'Maria 1',
  2: 'Maria 2',
  3: 'Valesia',
  4: 'Bar Bar',
  5: 'Kalispera',
  6: 'Infinity',
  7: 'Perla',
  8: 'Bob'
};

// =====================================================
// VESSELS API
// =====================================================
export async function getVessels() {
  try {
    const response = await fetch(`${API_URL}/vessels.php`);
    if (!response.ok) throw new Error('Failed to fetch vessels');
    const data = await response.json();
    // API returns { success: true, vessels: [...] }
    if (data.success && data.vessels) {
      return data.vessels;
    }
    // Fallback to hardcoded list if API fails
    return [
      { id: 8, name: 'Bob', type: 'Catamaran', model: 'Lagoon 42' },
      { id: 7, name: 'Perla', type: 'Catamaran', model: 'Lagoon 46' },
      { id: 6, name: 'Infinity', type: 'Catamaran', model: 'Bali 4.2' },
      { id: 1, name: 'Maria 1', type: 'Monohull', model: 'Jeanneau Sun Odyssey 449' },
      { id: 2, name: 'Maria 2', type: 'Monohull', model: 'Jeanneau yacht 54' },
      { id: 4, name: 'Bar Bar', type: 'Monohull', model: 'Beneteau Oceanis 46.1' },
      { id: 5, name: 'Kalispera', type: 'Monohull', model: 'Bavaria c42 Cruiser' },
      { id: 3, name: 'Valesia', type: 'Monohull', model: 'Bavaria c42 Cruiser' },
    ];
  } catch (error) {
    console.error('Error fetching vessels from API, using fallback:', error);
    // Return hardcoded list as fallback
    return [
      { id: 8, name: 'Bob', type: 'Catamaran', model: 'Lagoon 42' },
      { id: 7, name: 'Perla', type: 'Catamaran', model: 'Lagoon 46' },
      { id: 6, name: 'Infinity', type: 'Catamaran', model: 'Bali 4.2' },
      { id: 1, name: 'Maria 1', type: 'Monohull', model: 'Jeanneau Sun Odyssey 449' },
      { id: 2, name: 'Maria 2', type: 'Monohull', model: 'Jeanneau yacht 54' },
      { id: 4, name: 'Bar Bar', type: 'Monohull', model: 'Beneteau Oceanis 46.1' },
      { id: 5, name: 'Kalispera', type: 'Monohull', model: 'Bavaria c42 Cruiser' },
      { id: 3, name: 'Valesia', type: 'Monohull', model: 'Bavaria c42 Cruiser' },
    ];
  }
}

export async function createVessel(vessel: any, employeeCode?: string) {
  const response = await fetch(`${API_URL}/vessels.php`, {
    method: 'POST',
    headers: employeeCode
      ? { 'Content-Type': 'application/json', 'X-Employee-Code': employeeCode }
      : { 'Content-Type': 'application/json' },
    body: JSON.stringify(vessel)
  });
  if (!response.ok) throw new Error('Failed to create vessel');
  return response.json();
}

export async function updateVessel(id: string, vessel: any) {
  const response = await fetch(`${API_URL}/vessels.php?id=${id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(vessel)
  });
  if (!response.ok) throw new Error('Failed to update vessel');
  return response.json();
}

export async function deleteVessel(id: string) {
  const response = await fetch(`${API_URL}/vessels.php?id=${id}`, {
    method: 'DELETE'
  });
  if (!response.ok) throw new Error('Failed to delete vessel');
  return response.json();
}

// =====================================================
// BOOKINGS API
// =====================================================

/**
 * Get all bookings with optional filters
 * @param filters - Optional filters: vessel, startDate, endDate, limit, offset
 */
export async function getBookings(filters?: {
  vessel?: string;
  startDate?: string;
  endDate?: string;
  limit?: number;
  offset?: number;
}) {
  const params = new URLSearchParams();
  if (filters?.vessel) params.append('vessel', filters.vessel);
  if (filters?.startDate) params.append('startDate', filters.startDate);
  if (filters?.endDate) params.append('endDate', filters.endDate);
  if (filters?.limit) params.append('limit', filters.limit.toString());
  if (filters?.offset) params.append('offset', filters.offset.toString());

  const url = `${API_URL}/bookings.php${params.toString() ? '?' + params.toString() : ''}`;
  const response = await fetch(url, { headers: withCust() });
  if (!response.ok) throw new Error('Failed to fetch bookings');
  return response.json();
}

/**
 * Get single booking by booking number
 * @param bookingNumber - The booking number
 */
export async function getBooking(bookingNumber: string) {
  const response = await fetch(`${API_URL}/bookings.php?booking_number=${encodeURIComponent(bookingNumber)}`, { headers: withCust() });
  if (!response.ok) {
    if (response.status === 404) return null;
    throw new Error('Failed to fetch booking');
  }
  return response.json();
}

/**
 * Create new booking
 * @param booking - Booking data object
 */
export async function createBooking(booking: {
  bookingNumber: string;
  bookingData?: any;
  page2DataCheckIn?: any;
  page2DataCheckOut?: any;
  page3DataCheckIn?: any;
  page3DataCheckOut?: any;
  page4DataCheckIn?: any;
  page4DataCheckOut?: any;
}) {
  const response = await fetch(`${API_URL}/bookings.php`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(booking)
  });
  if (!response.ok) {
    if (response.status === 409) throw new Error('Booking already exists');
    throw new Error('Failed to create booking');
  }
  return response.json();
}

/**
 * Update existing booking
 * @param bookingNumber - The booking number
 * @param updates - Partial booking data to update
 */
export async function updateBooking(
  bookingNumber: string,
  updates: {
    bookingData?: any;
    page2DataCheckIn?: any;
    page2DataCheckOut?: any;
    page3DataCheckIn?: any;
    page3DataCheckOut?: any;
    page4DataCheckIn?: any;
    page4DataCheckOut?: any;
    synced?: boolean;
  }
) {
  const response = await fetch(`${API_URL}/bookings.php?booking_number=${encodeURIComponent(bookingNumber)}`, {
    method: 'PUT',
    headers: withCust({ 'Content-Type': 'application/json' }),
    body: JSON.stringify(updates)
  });
  if (!response.ok) {
    if (response.status === 404) throw new Error('Booking not found');
    throw new Error('Failed to update booking');
  }
  return response.json();
}

/**
 * Rename a booking's booking_number atomically and update its data.
 * Sends new_booking_number in the PUT body so the PHP backend does an atomic rename.
 */
export async function renameBooking(
  oldBookingNumber: string,
  newBookingNumber: string,
  bookingData: any
) {
  const response = await fetch(`${API_URL}/bookings.php?booking_number=${encodeURIComponent(oldBookingNumber)}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ bookingData, new_booking_number: newBookingNumber })
  });
  if (!response.ok) {
    if (response.status === 404) throw new Error('Booking not found');
    throw new Error('Failed to rename booking');
  }
  return response.json();
}

/**
 * Update charter status
 * @param bookingNumber - The booking number/code
 * @param status - New status (Option, Reservation, Confirmed, Cancelled, etc.)
 */
export async function updateCharterStatus(
  bookingNumber: string,
  status: string
) {
  console.log('📋 updateCharterStatus called:', { bookingNumber, status });

  const existing = await getBooking(bookingNumber);
  // bookings.php returns { success, booking: { booking_number, booking_data } } — never
  // `bookingData`. The old `existing.bookingData || existing` fallback therefore always
  // spread the whole HTTP envelope into booking_data (nested {success,booking} per save).
  const existingData = existing?.booking?.booking_data || existing?.bookingData || null;
  if (!existingData) {
    throw new Error('Booking not found');
  }

  const updatedBookingData = {
    ...existingData,
    status,
    updatedAt: new Date().toISOString()
  };

  const encodedBookingNumber = encodeURIComponent(bookingNumber);
  const response = await fetch(`${API_URL}/bookings.php?booking_number=${encodedBookingNumber}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ bookingData: updatedBookingData })
  });

  console.log('📋 API response status:', response.status);
  if (!response.ok) {
    if (response.status === 404) throw new Error('Booking not found');
    throw new Error('Failed to update status');
  }
  return response.json();
}

/**
 * 🔥 FIX 26: Update charter crew members
 * @param bookingNumber - The booking number/code
 * @param crewMembers - Array of crew member objects
 */
// CHARTERER_DATA_MARKER
export async function updateCharterCrew(
  bookingNumber: string,
  crewMembersOrPayload: Array<{
    name: string;
    passport: string;
    dateOfBirth?: string;
    nationality?: string;
  }> | { crewMembers?: any[]; chartererData?: any; skipperLicense?: string; extraLicenses?: string[]; skipperCleared?: boolean },
  extraPayload?: { chartererData?: any; skipperLicense?: string; extraLicenses?: string[]; skipperCleared?: boolean }
) {
  // Backward-compatible: accept old signature (array) OR new (object)
  let bodyPayload: any = { bookingNumber };
  if (Array.isArray(crewMembersOrPayload)) {
    bodyPayload.crewMembers = crewMembersOrPayload;
    if (extraPayload) {
      if (extraPayload.chartererData) bodyPayload.chartererData = extraPayload.chartererData;
      if (extraPayload.skipperLicense) bodyPayload.skipperLicense = extraPayload.skipperLicense;
      if (extraPayload.extraLicenses) bodyPayload.extraLicenses = extraPayload.extraLicenses;
      // v6.473: ρητή διαγραφή σκίπερ — περνά αυτούσια στο update-charter-crew.php
      if (extraPayload.skipperCleared) bodyPayload.skipperCleared = true;
    }
  } else {
    if (crewMembersOrPayload.crewMembers) bodyPayload.crewMembers = crewMembersOrPayload.crewMembers;
    if (crewMembersOrPayload.chartererData) bodyPayload.chartererData = crewMembersOrPayload.chartererData;
    if (crewMembersOrPayload.skipperLicense) bodyPayload.skipperLicense = crewMembersOrPayload.skipperLicense;
    if (crewMembersOrPayload.extraLicenses) bodyPayload.extraLicenses = crewMembersOrPayload.extraLicenses;
    if (crewMembersOrPayload.skipperCleared) bodyPayload.skipperCleared = true;
  }

  console.log('👥 Saving to bookings API...', bodyPayload);

  const response = await fetch(`${API_URL}/update-charter-crew.php`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(bodyPayload)
  });

  if (!response.ok) {
    throw new Error('Failed to save crew members');
  }

  console.log('✅ Crew saved successfully');
  return response.json();
}

/**
 * 🔥 Load charter crew members from API
 * @param bookingNumber - The booking number/code
 * @returns Array of crew members or null if not found
 */
export async function loadCharterCrew(bookingNumber: string) {
  console.log('👥 Loading crew from API...', { bookingNumber });

  try {
    const booking = await getBooking(bookingNumber);
    if (booking && booking.bookingData?.crewMembers) {
      console.log('✅ Crew loaded successfully:', booking.bookingData.crewMembers);
      return booking.bookingData.crewMembers;
    }
    console.log('ℹ️ No crew members found for booking');
    return null;
  } catch (error) {
    console.error('❌ Error loading crew:', error);
    return null;
  }
}

/**
 * 📋 Load charterer data from charter-archive.php
 * @param bookingNumber - The booking number/code
 * @returns chartererData object or null if not found
 */
export async function loadChartererData(bookingNumber: string) {
  console.log('📋 Loading charterer data from API...', { bookingNumber });
  try {
    const response = await fetch(`${API_URL}/charter-archive.php?booking_number=${encodeURIComponent(bookingNumber)}`);
    if (!response.ok) {
      console.log('ℹ️ No archive found for booking');
      return null;
    }
    const result = await response.json();
    const archiveData = result.data || {};
    const chartererData = archiveData.chartererData || null;
    if (chartererData) {
      console.log('✅ Charterer data loaded:', chartererData);
    } else {
      console.log('ℹ️ No charterer data in archive yet');
    }
    return chartererData;
  } catch (error) {
    console.error('❌ Error loading charterer data:', error);
    return null;
  }
}

/**
 * 📋 Save charterer data to charter-archive.php
 * Uses JSONB merge — preserves documents, crewMembers, and other keys
 * @param bookingNumber - The booking number/code
 * @param chartererData - Full charterer object with signature, timestamps, etc.
 * @returns Response from API
 */
export async function saveChartererData(bookingNumber: string, chartererData: any, employeeCode?: string) {
  console.log('📋 Saving charterer data to API...', { bookingNumber });
  const response = await fetch(`${API_URL}/charter-archive.php`, {
    method: 'POST',
    headers: employeeCode
      ? { 'Content-Type': 'application/json', 'X-Employee-Code': employeeCode }
      : withCust({ 'Content-Type': 'application/json' }),
    body: JSON.stringify({
      booking_number: bookingNumber,
      archive_data: {
        chartererData: chartererData
      }
    })
  });
  if (!response.ok) {
    throw new Error('Failed to save charterer data');
  }
  console.log('✅ Charterer data saved successfully');
  return response.json();
}

/**
 * Update charter payments
 * @param bookingNumber - The booking number/code
 * @param payments - Array of payment objects {date, amount}
 * @param paymentStatus - Payment status in Greek (ΑΝΕΞΟΦΛΗΤΟ, ΜΕΡΙΚΗ ΠΛΗΡΩΜΗ, ΕΞΟΦΛΗΜΕΝΟ)
 */
export async function updateCharterPayments(
  bookingNumber: string,
  payments: Array<{date: string, amount: number}>,
  paymentStatus: string
) {
  console.log('💰 updateCharterPayments called:', { bookingNumber, payments, paymentStatus });

  // First get the existing booking
  const existing = await getBooking(bookingNumber);
  console.log('💰 Existing booking:', existing);
  // Same envelope unwrap as updateCharterStatus — see the note there.
  const existingData = existing?.booking?.booking_data || existing?.bookingData || null;
  if (!existingData) {
    throw new Error('Booking not found');
  }

  // Update the bookingData with payments
  const updatedBookingData = {
    ...existingData,
    payments,
    paymentStatus,
    updatedAt: new Date().toISOString()
  };
  console.log('💰 Updated bookingData:', updatedBookingData);

  // 🔥 FIX: Send both bookingData (with payments inside) AND payment_status as top-level field
  const encodedBookingNumber = encodeURIComponent(bookingNumber);
  const response = await fetch(`${API_URL}/bookings.php?booking_number=${encodedBookingNumber}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      bookingData: updatedBookingData,
      payment_status: paymentStatus  // Top-level field for database
    })
  });

  console.log('💰 API response status:', response.status);
  const responseText = await response.text();
  console.log('💰 API response body:', responseText);

  if (!response.ok) {
    if (response.status === 404) throw new Error('Booking not found');
    throw new Error(`Failed to update payments: ${responseText}`);
  }

  try {
    return JSON.parse(responseText);
  } catch {
    return { success: true };
  }
}

/**
 * Delete booking
 * @param bookingNumber - The booking number
 */
export async function deleteBooking(bookingNumber: string) {
  const response = await fetch(`${API_URL}/bookings.php?booking_number=${encodeURIComponent(bookingNumber)}`, {
    method: 'DELETE'
  });
  if (!response.ok) {
    if (response.status === 404) throw new Error('Booking not found');
    throw new Error('Failed to delete booking');
  }
  return response.json();
}

/**
 * Save or update booking (upsert)
 * Checks if booking exists, creates or updates accordingly
 */
export async function saveBooking(
  bookingNumber: string,
  data: {
    bookingData?: any;
    page2DataCheckIn?: any;
    page2DataCheckOut?: any;
    page3DataCheckIn?: any;
    page3DataCheckOut?: any;
    page4DataCheckIn?: any;
    page4DataCheckOut?: any;
  }
) {
  try {
    // Try to get existing booking
    const existing = await getBooking(bookingNumber);

    if (existing) {
      // Update existing
      return await updateBooking(bookingNumber, data);
    } else {
      // Create new
      return await createBooking({
        bookingNumber,
        ...data
      });
    }
  } catch (error) {
    console.error('Error saving booking:', error);
    throw error;
  }
}

// =====================================================
// 🔥 API ONLY - NO LOCALSTORAGE FOR BOOKINGS
// All devices must see the same data from the database
// =====================================================

/**
 * Get all bookings from API (NO localStorage fallback)
 */
export async function getAllBookings(): Promise<any[]> {
  try {
    console.log('🔄 [API] Fetching all bookings...');
    const response = await fetch(`${API_URL}/bookings.php`);

    if (!response.ok) {
      throw new Error(`API request failed: ${response.status}`);
    }

    const data = await response.json();
    const bookingsObj = data.bookings || {};
    const bookingsList = Array.isArray(bookingsObj)
      ? bookingsObj
      : Object.values(bookingsObj).map((b: any) => b.bookingData || b);

    console.log(`✅ [API] Loaded ${bookingsList.length} bookings from database`);
    return bookingsList;
  } catch (error) {
    console.error('❌ [API] Failed to fetch bookings:', error);
    return []; // Return empty array on error - NO localStorage fallback
  }
}

/**
 * 🔥 VALIDATION: Check if charter party number already exists in API
 * @param charterCode - The charter party number to check
 * @param excludeBookingId - Optional booking ID to exclude (for edit mode)
 * @returns Object with isDuplicate flag and existing booking info if found

 */
function extractNum(code: string): string {
  return code.replace(/[^0-9]/g, "");
}

export async function checkDuplicateCharterCode(
  charterCode: string,
  excludeBookingId?: string
): Promise<{ isDuplicate: boolean; existingBooking?: any }> {
  try {
    if (!charterCode || !charterCode.trim()) {
      return { isDuplicate: false };
    }

    const codeToCheck = charterCode.trim().toLowerCase();
    console.log('🔍 [API Validation] Checking duplicate charter code:', codeToCheck);

    const allBookings = await getAllBookings();

    for (const booking of allBookings) {
      // Skip the booking being edited - check ALL possible identifier fields
      if (excludeBookingId) {
        const eid = excludeBookingId.toString().trim().toLowerCase();
        const bookingIds = [
          booking.id, booking.code, booking.booking_number,
          booking.bookingCode, booking.charterCode
        ].filter(Boolean).map((v: any) => v.toString().trim().toLowerCase());
        if (bookingIds.includes(eid)) {
          continue;
        }
      }

      // Skip orphan/empty records (booking_data < 100 chars means empty placeholder)
      const bookingDataStr = JSON.stringify(booking.bookingData || booking.booking_data || booking);
      if (bookingDataStr.length < 100) {
        console.log('⏭️ [API Validation] Skipping orphan/empty record:', booking.booking_number || booking.id);
        continue;
      }

      const existingCode = booking.code || booking.bookingCode || booking.charterCode || booking.booking_number;
      if (!existingCode) continue;

      // Exact match only (case-insensitive)
      console.log("🔍 Comparing:", extractNum(existingCode), "vs", extractNum(charterCode), "existing:", existingCode);
      if (extractNum(existingCode) === extractNum(charterCode)) {
        console.log('❌ [API Validation] Found duplicate charter code:', existingCode);
        return { isDuplicate: true, existingBooking: booking };
      }
    }

    console.log('✅ [API Validation] No duplicate charter code found');
    return { isDuplicate: false };
  } catch (error) {
    console.error('❌ [API Validation] Error checking duplicate:', error);
    // On error, return false to not block user (fail-open)
    return { isDuplicate: false };
  }
}

export type OverlapResult = {
  hasOverlap: boolean;
  overlappingBooking?: any;
  vessel?: { id: number; name: string };
  /** Ο server ΔΕΝ αποφάνθηκε (άγνωστο σκάφος, ασυμφωνία ταυτότητας, δίκτυο). Μπλοκάρει η αποθήκευση. */
  error?: string;
};

/**
 * 🔥 VALIDATION: Έλεγχος διπλοκράτησης — ΑΠΟΚΛΕΙΣΤΙΚΑ στον server.
 *
 * Ο browser ΔΕΝ κρίνει τίποτα εδώ: στέλνει σκάφος + ημερομηνίες και δείχνει
 * την απάντηση. Ο παλιός έλεγχος κατέβαζε όλους τους ναύλους και τους σύγκρινε
 * τοπικά με το vessel id που κρατούσε ο κάθε browser στο localStorage — έτσι
 * ίδιος ναύλος περνούσε από laptop και μπλοκαριζόταν από PC.
 *
 * Στέλνουμε ΚΑΙ id ΚΑΙ όνομα: ο server τα διασταυρώνει με τον πίνακα vessels
 * και αν διαφωνούν επιστρέφει 409 (χαλασμένη λίστα σκαφών στον client).
 *
 * @param vesselId - vessel id (vessels.id)
 * @param startDate - YYYY-MM-DD
 * @param endDate - YYYY-MM-DD
 * @param excludeBookingId - ο ναύλος που επεξεργαζόμαστε (self-exclusion, με αριθμό)
 * @param vesselName - όνομα σκάφους, όπως το βλέπει ο χρήστης
 */
export async function checkDateOverlap(
  vesselId: number | string | undefined,
  startDate: string,
  endDate: string,
  excludeBookingId?: string,
  vesselName?: string
): Promise<OverlapResult> {
  const hasVessel = (vesselId !== undefined && vesselId !== null && String(vesselId).trim() !== '')
    || !!(vesselName && vesselName.trim());
  if (!hasVessel || !startDate || !endDate) {
    return { hasOverlap: false };
  }

  const params = new URLSearchParams({ action: 'check_overlap', start: startDate, end: endDate });
  if (vesselId !== undefined && vesselId !== null && String(vesselId).trim() !== '') {
    params.set('vessel_id', String(vesselId));
  }
  if (vesselName && vesselName.trim()) params.set('vessel_name', vesselName.trim());
  if (excludeBookingId) params.set('exclude', String(excludeBookingId));

  console.log('🔍 [Overlap/server] check_overlap:', params.toString());

  try {
    const response = await fetch(`${API_URL}/bookings.php?${params.toString()}`, { cache: 'no-store' });
    const data = await response.json().catch(() => null);

    if (!response.ok || !data || data.success !== true) {
      const msg = (data && data.error) || `Ο έλεγχος διπλοκράτησης απέτυχε (HTTP ${response.status})`;
      console.error('❌ [Overlap/server] Ο server δεν αποφάνθηκε:', msg);
      return { hasOverlap: false, error: msg };
    }

    if (data.hasOverlap && data.conflict) {
      console.log('❌ [Overlap/server] Σύγκρουση:', data.conflict.bookingNumber,
        `(${data.conflict.startDate} - ${data.conflict.endDate})`);
      return { hasOverlap: true, overlappingBooking: data.conflict, vessel: data.vessel };
    }

    console.log('✅ [Overlap/server] Καθαρό για', data.vessel?.name);
    return { hasOverlap: false, vessel: data.vessel };
  } catch (error) {
    // Δεν κρίνουμε τοπικά: αν δεν μιλήσαμε με τον server, δεν έγινε έλεγχος.
    console.error('❌ [Overlap/server] Αποτυχία κλήσης:', error);
    return {
      hasOverlap: false,
      error: 'Ο έλεγχος διπλοκράτησης δεν ολοκληρώθηκε (πρόβλημα δικτύου). Δοκίμασε ξανά.'
    };
  }
}

/**
 * Get bookings for a specific vessel from API (NO localStorage fallback)
 */
export async function getBookingsByVessel(vesselId: number | string): Promise<any[]> {
  const vesselName = typeof vesselId === 'number' ? VESSEL_NAMES[vesselId] : vesselId;

  try {
    console.log(`🔄 [API] Fetching bookings for vessel: ${vesselName || vesselId}`);
    const response = await fetch(`${API_URL}/bookings.php?vessel=${encodeURIComponent(vesselName || String(vesselId))}`);

    if (!response.ok) {
      throw new Error(`API request failed: ${response.status}`);
    }

    const data = await response.json();
    const bookingsObj = data.bookings || {};
    const bookingsList = Array.isArray(bookingsObj)
      ? bookingsObj
      : Object.values(bookingsObj).map((b: any) => b.bookingData || b);

    console.log(`✅ [API] Loaded ${bookingsList.length} bookings for vessel ${vesselName || vesselId}`);
    return bookingsList;
  } catch (error) {
    console.error(`❌ [API] Failed to fetch bookings for vessel ${vesselId}:`, error);
    return []; // Return empty array on error - NO localStorage fallback
  }
}


// =====================================================
// CHAT MESSAGES API
// =====================================================

const CHAT_API_URL = 'https://yachtmanagementsuite.com/api/chat-messages.php';

export interface ChatMessage {
  id?: number;
  chat_id: string;
  booking_code: string;
  vessel_name?: string;
  customer_name?: string;
  sender_id: string;
  sender_name: string;
  sender_role: 'CUSTOMER' | 'TECHNICAL' | 'FINANCIAL' | 'BOOKING' | 'ADMIN';
  recipient_role: 'TECHNICAL' | 'FINANCIAL' | 'BOOKING' | 'ADMIN';
  category: 'TECHNICAL' | 'FINANCIAL' | 'BOOKING';
  message: string;
  timestamp?: string;
  read_status?: number;
  is_visitor?: number;
}

export interface Chat {
  id?: number;
  chat_id: string;
  booking_code: string;
  vessel_name?: string;
  customer_name?: string;
  category: 'TECHNICAL' | 'FINANCIAL' | 'BOOKING';
  status?: 'ACTIVE' | 'CLOSED';
  is_visitor?: number;
  messages?: ChatMessage[];
  unread_count?: number;
  last_message?: string;
  last_message_at?: string;
}

/**
 * Get all chats with optional filters
 */
export async function getChats(filters?: {
  category?: 'TECHNICAL' | 'FINANCIAL' | 'BOOKING' | 'ALL';
  booking_code?: string;
  recipient_role?: string;
  status?: 'ACTIVE' | 'CLOSED';
}): Promise<{ success: boolean; chats: Chat[] }> {
  try {
    const params = new URLSearchParams();
    params.append('action', 'chats');
    if (filters?.category) params.append('category', filters.category);
    if (filters?.booking_code) params.append('booking_code', filters.booking_code);
    if (filters?.recipient_role) params.append('recipient_role', filters.recipient_role);
    if (filters?.status) params.append('status', filters.status);

    const response = await fetch(`${CHAT_API_URL}?${params.toString()}`, { headers: authHeaders() });
    const result = await response.json();
    return result;
  } catch (error) {
    console.error('❌ Error fetching chats:', error);
    return { success: false, chats: [] };
  }
}

/**
 * Get messages for a specific chat
 */
export async function getChatMessages(chatId: string, since?: string, bookingCode?: string, viewerLang?: string): Promise<{ success: boolean; messages: ChatMessage[] }> {
  try {
    const params = new URLSearchParams();
    params.append('action', 'messages');
    params.append('chat_id', chatId);
    if (since) params.append('since', since);
    if (bookingCode) params.append('booking_code', bookingCode);
    if (viewerLang) params.append('viewer_lang', viewerLang);

    const response = await fetch(`${CHAT_API_URL}?${params.toString()}`, { headers: authHeaders() });
    const result = await response.json();
    return result;
  } catch (error) {
    console.error('❌ Error fetching messages:', error);
    return { success: false, messages: [] };
  }
}

/**
 * Get unread message count
 */
export async function getChatUnreadCount(filters: {
  booking_code?: string;
  role?: string;
}): Promise<{ success: boolean; unread_count: number }> {
  try {
    const params = new URLSearchParams();
    params.append('action', 'unread');
    if (filters.booking_code) params.append('booking_code', filters.booking_code);
    if (filters.role) params.append('role', filters.role);

    const response = await fetch(`${CHAT_API_URL}?${params.toString()}`);
    const result = await response.json();
    return result;
  } catch (error) {
    console.error('❌ Error fetching unread count:', error);
    return { success: false, unread_count: 0 };
  }
}

/**
 * Create a new chat
 */
export async function createChat(data: {
  chat_id?: string;
  booking_code: string;
  vessel_name?: string;
  customer_name?: string;
  category: 'TECHNICAL' | 'FINANCIAL' | 'BOOKING';
  is_visitor?: number;
}): Promise<{ success: boolean; chat: Chat; existing: boolean }> {
  try {
    const response = await fetch(`${CHAT_API_URL}?action=chat`, {
      method: 'POST',
      headers: authHeaders(),
      body: JSON.stringify(data)
    });
    const result = await response.json();
    return result;
  } catch (error) {
    console.error('❌ Error creating chat:', error);
    throw error;
  }
}

/**
 * Send a chat message
 */
export async function sendChatMessage(data: {
  chat_id: string;
  booking_code: string;
  vessel_name?: string;
  customer_name?: string;
  sender_id: string;
  sender_name: string;
  sender_role: 'CUSTOMER' | 'TECHNICAL' | 'FINANCIAL' | 'BOOKING' | 'ADMIN';
  recipient_role: 'TECHNICAL' | 'FINANCIAL' | 'BOOKING' | 'ADMIN';
  category: 'TECHNICAL' | 'FINANCIAL' | 'BOOKING';
  message: string;
  is_visitor?: number;
  lang?: string;
}): Promise<{ success: boolean; message: ChatMessage }> {
  try {
    const response = await fetch(`${CHAT_API_URL}?action=message`, {
      method: 'POST',
      headers: authHeaders(),
      body: JSON.stringify(data)
    });
    const result = await response.json();
    return result;
  } catch (error) {
    console.error('❌ Error sending message:', error);
    throw error;
  }
}

/**
 * Mark messages as read
 */
export async function markChatMessagesRead(chatId: string, reader: string, bookingCode?: string): Promise<{ success: boolean; updated: number }> {
  try {
    const body: any = { chat_id: chatId, reader };
    if (bookingCode) body.booking_code = bookingCode;
    const response = await fetch(`${CHAT_API_URL}?action=mark-read`, {
      method: 'POST',
      headers: authHeaders(),
      body: JSON.stringify(body)
    });
    const result = await response.json();
    return result;
  } catch (error) {
    console.error('❌ Error marking messages as read:', error);
    return { success: false, updated: 0 };
  }
}

/**
 * Update chat status (ACTIVE/CLOSED)
 */
export async function updateChatStatus(chatId: string, status: 'ACTIVE' | 'CLOSED'): Promise<{ success: boolean; updated: number }> {
  try {
    const response = await fetch(`${CHAT_API_URL}?action=chat-status`, {
      method: 'PUT',
      headers: authHeaders(),
      body: JSON.stringify({ chat_id: chatId, status })
    });
    const result = await response.json();
    return result;
  } catch (error) {
    console.error('❌ Error updating chat status:', error);
    return { success: false, updated: 0 };
  }
}

// =====================================================
// 🔥 FIX 31: AUTO-EXPIRE OPTIONS AFTER 6 DAYS
// =====================================================

/**
 * Check for expired options (older than 6 days) and update their status
 * This function should be called on dashboard load and during auto-refresh
 *
 * @returns Array of expired charter codes
 */
export async function checkExpiredOptions(): Promise<string[]> {
  const expiredCharters: string[] = [];
  const now = new Date();
  const EXPIRE_DAYS = 6;

  try {
    console.log('🔍 Checking for expired options...');

    // Get all bookings from API
    const allBookings = await getAllBookings();

    for (const charter of allBookings) {
      // Only check "Option" or "Pending" status
      if (charter.status !== 'Option' && charter.status !== 'Pending') {
        continue;
      }

      // Get creation date - use createdAt, created_at, or startDate as fallback
      const createdDateStr = charter.createdAt || charter.created_at || charter.startDate;
      if (!createdDateStr) continue;

      const createdDate = new Date(createdDateStr);
      const daysDiff = (now.getTime() - createdDate.getTime()) / (1000 * 60 * 60 * 24);

      if (daysDiff >= EXPIRE_DAYS) {
        console.log(`⏰ Option expired: ${charter.code} - ${daysDiff.toFixed(1)} days old`);

        try {
          // Update status to "Expired" via API
          const updatedCharter = { ...charter, status: 'Expired' };
          await saveBooking(charter.code, { bookingData: updatedCharter });

          expiredCharters.push(charter.code);
          console.log(`✅ Charter ${charter.code} marked as Expired`);
        } catch (updateError) {
          console.error(`❌ Failed to expire charter ${charter.code}:`, updateError);
        }
      }
    }

    if (expiredCharters.length > 0) {
      console.log(`⚠️ Expired ${expiredCharters.length} option(s):`, expiredCharters);
    } else {
      console.log('✅ No expired options found');
    }

    return expiredCharters;
  } catch (error) {
    console.error('❌ Error checking expired options:', error);
    return [];
  }
}

// =====================================================
// PAGE 1 SPECIFIC API - Booking Details
// =====================================================

/**
 * Page 1 form data interface
 */
export interface Page1FormData {
  bookingNumber: string;
  vesselName?: string;
  vesselId?: string;
  vesselCategory?: string;
  checkInDate?: string;
  checkInTime?: string;
  checkOutDate?: string;
  checkOutTime?: string;
  departurePort?: string;
  arrivalPort?: string;
  skipperFirstName?: string;
  skipperLastName?: string;
  skipperAddress?: string;
  skipperEmail?: string;
  skipperPhone?: string;
  skipperNationality?: string;
  skipperPassport?: string;
  phoneCountryCode?: string;
  mode?: 'in' | 'out';
  status?: string;
  source?: 'page1' | 'fleetManagement';  // 🔥 Track where booking was created
}

/**
 * Get Page 1 booking details from API
 * @param bookingNumber - The booking number to load
 * @returns Page 1 form data or null
 */
export async function getPage1Data(bookingNumber: string): Promise<Page1FormData | null> {
  try {
    const encodedBN = encodeURIComponent(bookingNumber);
    const response = await fetch(`${PAGE1_API_URL}?booking_number=${encodedBN}`);

    if (!response.ok) {
      console.warn('⚠️ Page 1 API GET failed:', response.status);
      return null;
    }

    const result = await response.json();

    if (result.success && result.bookingDetails) {
      console.log('✅ Page 1 data loaded from API:', bookingNumber);
      return result.bookingDetails;
    }

    return null;
  } catch (error) {
    console.warn('⚠️ Page 1 API error:', error);
    return null;
  }
}

/**
 * Save Page 1 booking details to API (POST for new, PUT for update)
 * @param bookingNumber - The booking number
 * @param data - Page 1 form data
 * @param isNew - Whether this is a new booking (POST) or update (PUT)
 */
export async function savePage1Data(
  bookingNumber: string,
  data: Page1FormData,
  isNew: boolean = false
): Promise<{ success: boolean; message?: string }> {
  try {
    const method = isNew ? 'POST' : 'PUT';

    const response = await fetch(PAGE1_API_URL, {
      method,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        bookingNumber,
        ...data
      })
    });

    const result = await response.json();

    if (result.success) {
      console.log(`✅ Page 1 data ${isNew ? 'created' : 'updated'} via API:`, bookingNumber);
      return { success: true, message: result.message };
    }

    // If POST fails with 409 (already exists), try PUT
    if (!result.success && response.status === 409 && isNew) {
      console.log('📝 Booking exists, updating instead...');
      return savePage1Data(bookingNumber, data, false);
    }

    console.warn('⚠️ Page 1 API save failed:', result.error);
    return { success: false, message: result.error };
  } catch (error) {
    console.warn('⚠️ Page 1 API save error:', error);
    return { success: false, message: String(error) };
  }
}

/**
 * Delete Page 1 booking data from API
 * @param bookingNumber - The booking number to delete
 */
export async function deletePage1Data(bookingNumber: string): Promise<boolean> {
  try {
    const encodedBN = encodeURIComponent(bookingNumber);
    const response = await fetch(`${PAGE1_API_URL}?booking_number=${encodedBN}`, {
      method: 'DELETE'
    });

    const result = await response.json();

    if (result.success) {
      console.log('✅ Page 1 data deleted from API:', bookingNumber);
      return true;
    }

    return false;
  } catch (error) {
    console.warn('⚠️ Page 1 API delete error:', error);
    return false;
  }
}

/**
 * Get Page 1 data from API (NO localStorage)
 * @param bookingNumber - The booking number to load
 */
export async function getPage1DataHybrid(bookingNumber: string): Promise<Page1FormData | null> {
  try {
    const apiData = await getPage1Data(bookingNumber);
    return apiData;
  } catch (error) {
    console.error('❌ Page 1 API failed:', error);
    return null;
  }
}

/**
 * Save Page 1 data to API (NO localStorage)
 * @param bookingNumber - The booking number
 * @param data - Page 1 form data
 */
export async function savePage1DataHybrid(
  bookingNumber: string,
  data: Page1FormData
): Promise<{ success: boolean; synced: boolean }> {
  // 🟡 PREVIEW: πριν την ημέρα check-in δεν γράφουμε τίποτα στη βάση.
  if (isCheckinPreview()) {
    console.log('🟡 PREVIEW — skip Page 1 save:', bookingNumber);
    return { success: true, synced: false };
  }
  try {
    // Check if booking exists in API
    const existing = await getPage1Data(bookingNumber);
    const isNew = !existing;

    const result = await savePage1Data(bookingNumber, data, isNew);
    return { success: result.success, synced: result.success };
  } catch (error) {
    console.error('❌ Page 1 API save failed:', error);
    return { success: false, synced: false };
  }
}

// =====================================================
// WINTER/TASK CHECKIN API - Per Vessel Data Storage
// =====================================================

/**
 * Generic interface for checkin data
 */
export interface CheckinData {
  vesselId: number;
  vesselName: string;
  category?: string;  // For task category checkins
  sections: any;
  customSections?: any;
  generalNotes?: string;
  lastSaved: string;
}

/**
 * Get checkin data from API
 * @param endpoint - API endpoint (e.g., 'winterization-checkin', 'winter-inventory')
 * @param vesselId - The vessel ID
 * @param category - Optional category for task checkins
 */
export async function getCheckinData(
  endpoint: string,
  vesselId: number,
  category?: string
): Promise<CheckinData | null> {
  try {
    const url = category
      ? `${API_URL}/${endpoint}.php?vessel_id=${vesselId}&category=${encodeURIComponent(category)}`
      : `${API_URL}/${endpoint}.php?vessel_id=${vesselId}`;

    const response = await fetch(url);

    if (!response.ok) {
      if (response.status === 404) return null;
      throw new Error(`API request failed: ${response.status}`);
    }

    const result = await response.json();
    console.log(`✅ ${endpoint} data loaded from API for vessel ${vesselId}`);
    return result.data || result;
  } catch (error) {
    console.warn(`⚠️ ${endpoint} API GET failed:`, error);
    return null;
  }
}

/**
 * Save checkin data to API
 * @param endpoint - API endpoint
 * @param data - Checkin data to save
 */
export async function saveCheckinData(
  endpoint: string,
  data: CheckinData
): Promise<{ success: boolean; message?: string }> {
  const apiUrl = `${API_URL}/${endpoint}.php`;
  console.log(`🔄 API POST to: ${apiUrl}`, { vesselId: data.vesselId, dataKeys: Object.keys(data) });

  try {
    const response = await fetch(apiUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    });

    console.log(`📡 API response status: ${response.status} ${response.statusText}`);

    if (!response.ok) {
      const errorText = await response.text();
      console.error(`❌ API HTTP error: ${response.status}`, errorText);
      return { success: false, message: `HTTP ${response.status}: ${errorText}` };
    }

    const result = await response.json();
    console.log(`📡 API response:`, result);

    if (result.success) {
      console.log(`✅ ${endpoint} data saved to API for vessel ${data.vesselId}`);
      return { success: true, message: result.message };
    }

    console.warn(`⚠️ ${endpoint} API save failed:`, result.error || result);
    return { success: false, message: result.error || 'Unknown error' };
  } catch (error) {
    console.error(`❌ ${endpoint} API save error:`, error);
    return { success: false, message: String(error) };
  }
}

/**
 * Get checkin data from API (NO localStorage)
 */
export async function getCheckinDataHybrid(
  endpoint: string,
  vesselId: number,
  localStorageKey: string,
  category?: string
): Promise<CheckinData | null> {
  try {
    const apiData = await getCheckinData(endpoint, vesselId, category);
    return apiData;
  } catch (error) {
    console.error(`❌ ${endpoint} API failed:`, error);
    return null;
  }
}

/**
 * Save checkin data to API (NO localStorage)
 */
export async function saveCheckinDataHybrid(
  endpoint: string,
  data: CheckinData,
  localStorageKey: string
): Promise<{ success: boolean; synced: boolean }> {
  try {
    const result = await saveCheckinData(endpoint, data);
    return { success: result.success, synced: result.success };
  } catch (error) {
    console.error(`❌ ${endpoint} API save failed:`, error);
    return { success: false, synced: false };
  }
}

// =====================================================
// WINTERIZATION CHECKIN API
// =====================================================

export async function getWinterizationCheckin(vesselId: number): Promise<CheckinData | null> {
  const vesselName = VESSEL_NAMES[vesselId] || '';
  const localKey = `winterization_${vesselName.replace(/\s+/g, '_').toLowerCase()}_data`;
  return getCheckinDataHybrid('winterization-checkin', vesselId, localKey);
}

export async function saveWinterizationCheckin(vesselId: number, sections: any, customSections: any, generalNotes: string): Promise<{ success: boolean; synced: boolean }> {
  const vesselName = VESSEL_NAMES[vesselId] || '';
  const localKey = `winterization_${vesselName.replace(/\s+/g, '_').toLowerCase()}_data`;
  return saveCheckinDataHybrid('winterization-checkin', {
    vesselId,
    vesselName,
    sections,
    customSections,
    generalNotes,
    lastSaved: new Date().toISOString()
  }, localKey);
}

// =====================================================
// WINTER MAINTENANCE INVENTORY API
// =====================================================

export async function getWinterInventory(vesselId: number): Promise<CheckinData | null> {
  const vesselName = VESSEL_NAMES[vesselId] || '';
  const localKey = `winter_inventory_${vesselName.replace(/\s+/g, '_').toLowerCase()}`;
  return getCheckinDataHybrid('winter-inventory', vesselId, localKey);
}

export async function saveWinterInventory(vesselId: number, sections: any, customSections: any, generalNotes: string): Promise<{ success: boolean; synced: boolean }> {
  const vesselName = VESSEL_NAMES[vesselId] || '';
  const localKey = `winter_inventory_${vesselName.replace(/\s+/g, '_').toLowerCase()}`;
  return saveCheckinDataHybrid('winter-inventory', {
    vesselId,
    vesselName,
    sections,
    customSections,
    generalNotes,
    lastSaved: new Date().toISOString()
  }, localKey);
}

// =====================================================
// WINTER SAFETY EQUIPMENT API
// =====================================================

export async function getWinterSafety(vesselId: number): Promise<CheckinData | null> {
  const vesselName = VESSEL_NAMES[vesselId] || '';
  const localKey = `winter_safety_equipment_v3_${vesselName.replace(/\s+/g, '_').toLowerCase()}`;
  return getCheckinDataHybrid('safety-equipment', vesselId, localKey);
}

export async function saveWinterSafety(vesselId: number, sections: any, customSections: any, generalNotes: string): Promise<{ success: boolean; synced: boolean }> {
  const vesselName = VESSEL_NAMES[vesselId] || '';
  const localKey = `winter_safety_equipment_v3_${vesselName.replace(/\s+/g, '_').toLowerCase()}`;
  return saveCheckinDataHybrid('safety-equipment', {
    vesselId,
    vesselName,
    sections,
    customSections,
    generalNotes,
    lastSaved: new Date().toISOString()
  }, localKey);
}

// =====================================================
// WINTER TAKEOVER API
// =====================================================

export async function getWinterTakeover(vesselId: number): Promise<CheckinData | null> {
  const vesselName = VESSEL_NAMES[vesselId] || '';
  const localKey = `winter_take_over_v3_${vesselName.replace(/\s+/g, '_').toLowerCase()}`;
  return getCheckinDataHybrid('winter-takeover', vesselId, localKey);
}

export async function saveWinterTakeover(vesselId: number, sections: any, customSections: any, generalNotes: string): Promise<{ success: boolean; synced: boolean }> {
  const vesselName = VESSEL_NAMES[vesselId] || '';
  const localKey = `winter_take_over_v3_${vesselName.replace(/\s+/g, '_').toLowerCase()}`;
  return saveCheckinDataHybrid('winter-takeover', {
    vesselId,
    vesselName,
    sections,
    customSections,
    generalNotes,
    lastSaved: new Date().toISOString()
  }, localKey);
}

// =====================================================
// TASK CATEGORY CHECKIN API
// =====================================================

export async function getTaskCheckin(vesselId: number, category: string): Promise<CheckinData | null> {
  const vesselName = VESSEL_NAMES[vesselId] || '';
  const localKey = `task_${category}_${vesselName.replace(/\s+/g, '_').toLowerCase()}_data`;
  return getCheckinDataHybrid('task-checkins', vesselId, localKey, category);
}

export async function saveTaskCheckin(vesselId: number, category: string, sections: any, customSections: any, generalNotes: string): Promise<{ success: boolean; synced: boolean }> {
  const vesselName = VESSEL_NAMES[vesselId] || '';
  const localKey = `task_${category}_${vesselName.replace(/\s+/g, '_').toLowerCase()}_data`;
  return saveCheckinDataHybrid('task-checkins', {
    vesselId,
    vesselName,
    category,
    sections,
    customSections,
    generalNotes,
    lastSaved: new Date().toISOString()
  }, localKey);
}

// =====================================================
// PAGE 2 API - Crew List & Passengers
// =====================================================

const PAGE2_API_URL = `${API_BASE}/page2.php`;

export interface CrewMember {
  firstName?: string;
  lastName?: string;
  nationality?: string;
  passportNumber?: string;
  dateOfBirth?: string;
  placeOfBirth?: string;
  role?: string;
}

/**
 * Get Page 2 crew data from API
 * @param bookingNumber - The booking number
 */
export async function getPage2Data(bookingNumber: string): Promise<{ crewList: CrewMember[] } | null> {
  try {
    const encodedBN = encodeURIComponent(bookingNumber);
    const response = await fetch(`${PAGE2_API_URL}?booking_number=${encodedBN}`);

    if (!response.ok) {
      console.warn('⚠️ Page 2 API GET failed:', response.status);
      return null;
    }

    const result = await response.json();

    if (result.success && result.crewList) {
      console.log('✅ Page 2 data loaded from API:', bookingNumber);
      return { crewList: result.crewList };
    }

    return null;
  } catch (error) {
    console.warn('⚠️ Page 2 API error:', error);
    return null;
  }
}

/**
 * Save Page 2 crew data to API
 * @param bookingNumber - The booking number
 * @param crewList - Array of crew members
 */
export async function savePage2Data(
  bookingNumber: string,
  crewList: CrewMember[]
): Promise<{ success: boolean; message?: string }> {
  try {
    const response = await fetch(PAGE2_API_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        bookingNumber,
        crewList
      })
    });

    const result = await response.json();

    if (result.success) {
      console.log('✅ Page 2 data saved to API:', bookingNumber);
      return { success: true, message: result.message };
    }

    // If POST fails with 409 (already exists), try PUT
    if (response.status === 409) {
      console.log('📝 Page 2 data exists, updating...');
      const putResponse = await fetch(PAGE2_API_URL, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ bookingNumber, crewList })
      });
      const putResult = await putResponse.json();
      return { success: putResult.success, message: putResult.message };
    }

    console.warn('⚠️ Page 2 API save failed:', result.error);
    return { success: false, message: result.error };
  } catch (error) {
    console.warn('⚠️ Page 2 API save error:', error);
    return { success: false, message: String(error) };
  }
}

/**
 * Get Page 2 data from API (NO localStorage)
 */
export async function getPage2DataHybrid(bookingNumber: string, mode: 'in' | 'out'): Promise<any | null> {
  try {
    const response = await fetch(`${PAGE2_API_URL}?booking_number=${encodeURIComponent(bookingNumber)}&mode=${mode}`);
    if (response.ok) {
      const result = await response.json();
      if (result.success && result.checklistData) {
        console.log('✅ Page 2 data loaded from API');
        return result.checklistData;
      }
    }
    return null;
  } catch (error) {
    console.error('❌ Page 2 API failed:', error);
    return null;
  }
}

/**
 * Save Page 2 data to API (NO localStorage)
 * 🔥 FIX: Send checklistData directly to API instead of through savePage2Data (which wraps as crewList)
 */
export async function savePage2DataHybrid(
  bookingNumber: string,
  data: any,
  mode: 'in' | 'out'
): Promise<{ success: boolean; synced: boolean }> {
  // 🟡 PREVIEW: πριν την ημέρα check-in δεν γράφουμε τίποτα στη βάση.
  if (isCheckinPreview()) {
    console.log('🟡 PREVIEW — skip Page 2 save:', bookingNumber, mode);
    return { success: true, synced: false };
  }
  try {
    // 🔴 Stamp problematic flags before persisting (see stampProblematic).
    const stamped = stampProblematic(data);
    // 🔥 FIX: Call API directly with correct structure
    // The API expects { bookingNumber, checklistData, mode } at top level
    const response = await fetch(PAGE2_API_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        bookingNumber,
        checklistData: stamped,
        mode: mode
      })
    });

    const result = await response.json();

    if (result.success) {
      console.log('✅ Page 2 checklist data saved to API:', bookingNumber, mode);
      return { success: true, synced: true };
    }

    // If POST fails with 409 (already exists), try PUT
    if (response.status === 409) {
      console.log('📝 Page 2 data exists, updating via PUT...');
      const putResponse = await fetch(PAGE2_API_URL, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          bookingNumber,
          checklistData: stamped,
          mode: mode
        })
      });
      const putResult = await putResponse.json();
      if (putResult.success) {
        console.log('✅ Page 2 checklist data updated via PUT:', bookingNumber, mode);
        return { success: true, synced: true };
      }
    }

    console.warn('⚠️ Page 2 API save failed:', result.error || result.message);
    return { success: false, synced: false };
  } catch (error) {
    console.error('❌ Page 2 API save failed:', error);
    return { success: false, synced: false };
  }
}

// =====================================================
// PAGE 3 API - Equipment Checklist
// =====================================================

const PAGE3_API_URL = `${API_BASE}/page3.php`;

export interface Page3EquipmentData {
  checklistData?: any;
  diversReport?: string | null;  // top-level (dedicated DB column page3_checklist.divers_report)
  safetyEquipment?: any;
  navigationEquipment?: any;
  galleyEquipment?: any;
  deckEquipment?: any;
  cabinEquipment?: any;
  notes?: string;
  checkedBy?: string;
  checkedAt?: string;
}

/**
 * Get Page 3 equipment data from API
 */
export async function getPage3Data(bookingNumber: string): Promise<Page3EquipmentData | null> {
  try {
    const encodedBN = encodeURIComponent(bookingNumber);
    const response = await fetch(`${PAGE3_API_URL}?booking_number=${encodedBN}`);

    if (!response.ok) {
      console.warn('⚠️ Page 3 API GET failed:', response.status);
      return null;
    }

    const result = await response.json();

    if (result.success && result.equipmentData) {
      console.log('✅ Page 3 data loaded from API:', bookingNumber);
      return result.equipmentData;
    }

    return null;
  } catch (error) {
    console.warn('⚠️ Page 3 API error:', error);
    return null;
  }
}

/**
 * Save Page 3 equipment data to API
 */
export async function savePage3Data(
  bookingNumber: string,
  data: Page3EquipmentData
): Promise<{ success: boolean; message?: string }> {
  try {
    const response = await fetch(PAGE3_API_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ bookingNumber, ...data })
    });

    const result = await response.json();

    if (result.success) {
      console.log('✅ Page 3 data saved to API:', bookingNumber);
      return { success: true, message: result.message };
    }

    // If POST fails with 409, try PUT
    if (response.status === 409) {
      console.log('📝 Page 3 data exists, updating...');
      const putResponse = await fetch(PAGE3_API_URL, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ bookingNumber, ...data })
      });
      const putResult = await putResponse.json();
      return { success: putResult.success, message: putResult.message };
    }

    console.warn('⚠️ Page 3 API save failed:', result.error);
    return { success: false, message: result.error };
  } catch (error) {
    console.warn('⚠️ Page 3 API save error:', error);
    return { success: false, message: String(error) };
  }
}

/**
 * Get Page 3 data from API (NO localStorage)
 */
export async function getPage3DataHybrid(bookingNumber: string, mode: 'in' | 'out'): Promise<any | null> {
  try {
    const response = await fetch(`${PAGE3_API_URL}?booking_number=${encodeURIComponent(bookingNumber)}&mode=${mode}`);
    if (response.ok) {
      const result = await response.json();
      // Accept rows that have checklist_data OR only divers_report (defensive — page3 saves typically include both)
      if (result.success && (result.checklistData || result.diversReport)) {
        console.log('✅ Page 3 data loaded from API');
        // Merge top-level diversReport into the flat shape the caller already consumes
        return { ...(result.checklistData ?? {}), diversReport: result.diversReport ?? null };
      }
    }
    return null;
  } catch (error) {
    console.error('❌ Page 3 API failed:', error);
    return null;
  }
}

/**
 * Save Page 3 data to API (NO localStorage)
 */
/**
 * 🔴 Stamp `problematic` on every inventory item before persisting to DB.
 * problematic = check-in item χωρίς OK αλλά με φωτό (χαλασμένο πριν τον ναύλο).
 * Έτσι το flag persist-άρει στο checklist_data και φαίνεται ξανά στο check-out reference.
 * Γενικός recursive walk: πιάνει όλα τα section arrays (equipment/hull/dinghy/... & page2 sections).
 */
function stampProblematic(node: any): any {
  if (Array.isArray(node)) return node.map(stampProblematic);
  if (node && typeof node === 'object') {
    const out: any = {};
    for (const k in node) out[k] = stampProblematic(node[k]);
    if ('inOk' in out && 'media' in out) {
      out.problematic = !out.inOk && ((out.media?.length || 0) > 0);
    }
    return out;
  }
  return node;
}

export async function savePage3DataHybrid(
  bookingNumber: string,
  data: any,
  mode: 'in' | 'out'
): Promise<{ success: boolean; synced: boolean }> {
  // 🟡 PREVIEW: πριν την ημέρα check-in δεν γράφουμε τίποτα στη βάση (και το auto-save/2s).
  if (isCheckinPreview()) {
    console.log('🟡 PREVIEW — skip Page 3 save:', bookingNumber, mode);
    return { success: true, synced: false };
  }
  try {
    // Hoist diversReport out of checklistData so it goes to the dedicated DB column (page3_checklist.divers_report).
    // The PHP endpoint also strips it defensively, but doing it here keeps payload semantics clean.
    const { diversReport, ...checklistRest } = (data ?? {}) as { diversReport?: string | null; [k: string]: any };
    const apiData = {
      checklistData: stampProblematic(checklistRest),
      diversReport: diversReport ?? null,
      mode: mode,
      lastSaved: new Date().toISOString()
    };
    const result = await savePage3Data(bookingNumber, apiData);
    return { success: result.success, synced: result.success };
  } catch (error) {
    console.error('❌ Page 3 API save failed:', error);
    return { success: false, synced: false };
  }
}

// =====================================================
// PAGE 4 API - Vessel Inspection
// =====================================================

const PAGE4_API_URL = `${API_BASE}/page4.php`;

export interface Page4InspectionData {
  inspectionType?: string;
  hullCondition?: string;
  deckCondition?: string;
  interiorCondition?: string;
  engineHours?: number;
  fuelLevel?: number;
  waterLevel?: number;
  batteryLevel?: number;
  damagesFound?: any[];
  photos?: any[];
  floorplanAnnotations?: any[];
  inspectorName?: string;
  inspectorSignature?: string;
  inspectionDate?: string;
  notes?: string;
}

/**
 * Get Page 4 inspection data from API
 */
export async function getPage4Data(bookingNumber: string): Promise<Page4InspectionData | null> {
  try {
    const encodedBN = encodeURIComponent(bookingNumber);
    const response = await fetch(`${PAGE4_API_URL}?booking_number=${encodedBN}`);

    if (!response.ok) {
      console.warn('⚠️ Page 4 API GET failed:', response.status);
      return null;
    }

    const result = await response.json();

    if (result.success && result.inspectionData) {
      console.log('✅ Page 4 data loaded from API:', bookingNumber);
      return result.inspectionData;
    }

    return null;
  } catch (error) {
    console.warn('⚠️ Page 4 API error:', error);
    return null;
  }
}

/**
 * Save Page 4 inspection data to API
 */
export async function savePage4Data(
  bookingNumber: string,
  data: Page4InspectionData
): Promise<{ success: boolean; message?: string }> {
  try {
    const response = await fetch(PAGE4_API_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ bookingNumber, ...data })
    });

    const result = await response.json();

    if (result.success) {
      console.log('✅ Page 4 data saved to API:', bookingNumber);
      return { success: true, message: result.message };
    }

    // If POST fails with 409, try PUT
    if (response.status === 409) {
      console.log('📝 Page 4 data exists, updating...');
      const putResponse = await fetch(PAGE4_API_URL, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ bookingNumber, ...data })
      });
      const putResult = await putResponse.json();
      return { success: putResult.success, message: putResult.message };
    }

    console.warn('⚠️ Page 4 API save failed:', result.error);
    return { success: false, message: result.error };
  } catch (error) {
    console.warn('⚠️ Page 4 API save error:', error);
    return { success: false, message: String(error) };
  }
}

/**
 * Get Page 4 data from API (NO localStorage)
 */
export async function getPage4DataHybrid(bookingNumber: string, mode: 'in' | 'out'): Promise<any | null> {
  try {
    const response = await fetch(`${PAGE4_API_URL}?booking_number=${encodeURIComponent(bookingNumber)}&mode=${mode}`);
    if (response.ok) {
      const result = await response.json();
      if (result.success && result.checklistData) {
        console.log('✅ Page 4 data loaded from API');
        return result.checklistData;
      }
    }
    return null;
  } catch (error) {
    console.error('❌ Page 4 API failed:', error);
    return null;
  }
}

/**
 * Save Page 4 data to API (NO localStorage)
 */
export async function savePage4DataHybrid(
  bookingNumber: string,
  data: any,
  mode: 'in' | 'out'
): Promise<{ success: boolean; synced: boolean }> {
  try {
    const apiData = {
      checklistData: data,
      mode: mode,
      lastSaved: new Date().toISOString()
    };
    const result = await savePage4Data(bookingNumber, apiData as any);
    return { success: result.success, synced: result.success };
  } catch (error) {
    console.error('❌ Page 4 API save failed:', error);
    return { success: false, synced: false };
  }
}

// =====================================================
// PAGE 5 API - Final Agreement & Signatures
// =====================================================

const PAGE5_API_URL = `${API_BASE}/page5.php`;

export interface Page5AgreementData {
  agreementType?: string;
  termsAccepted?: boolean;
  depositAmount?: number;
  depositPaid?: boolean;
  depositMethod?: string;
  damageDeposit?: number;
  fuelCharge?: number;
  otherCharges?: any[];
  totalAmount?: number;
  skipperSignature?: string;
  skipperSignedAt?: string;
  companySignature?: string;
  companySignedAt?: string;
  companyRepresentative?: string;
  pdfGenerated?: boolean;
  pdfUrl?: string;
  emailSent?: boolean;
  emailSentAt?: string;
  notes?: string;
}

/**
 * Get Page 5 agreement data from API
 */
export async function getPage5Data(bookingNumber: string): Promise<Page5AgreementData | null> {
  try {
    const encodedBN = encodeURIComponent(bookingNumber);
    const response = await fetch(`${PAGE5_API_URL}?booking_number=${encodedBN}`);

    if (!response.ok) {
      console.warn('⚠️ Page 5 API GET failed:', response.status);
      return null;
    }

    const result = await response.json();

    if (result.success && result.agreementData) {
      console.log('✅ Page 5 data loaded from API:', bookingNumber);
      return result.agreementData;
    }

    return null;
  } catch (error) {
    console.warn('⚠️ Page 5 API error:', error);
    return null;
  }
}

/**
 * Save Page 5 agreement data to API
 */
export async function savePage5Data(
  bookingNumber: string,
  data: Page5AgreementData
): Promise<{ success: boolean; message?: string }> {
  try {
    const response = await fetch(PAGE5_API_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ bookingNumber, ...data })
    });

    const result = await response.json();

    if (result.success) {
      console.log('✅ Page 5 data saved to API:', bookingNumber);
      return { success: true, message: result.message };
    }

    // If POST fails with 409, try PUT
    if (response.status === 409) {
      console.log('📝 Page 5 data exists, updating...');
      const putResponse = await fetch(PAGE5_API_URL, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ bookingNumber, ...data })
      });
      const putResult = await putResponse.json();
      return { success: putResult.success, message: putResult.message };
    }

    console.warn('⚠️ Page 5 API save failed:', result.error);
    return { success: false, message: result.error };
  } catch (error) {
    console.warn('⚠️ Page 5 API save error:', error);
    return { success: false, message: String(error) };
  }
}

/**
 * Get Page 5 data from API (NO localStorage)
 */
export async function getPage5DataHybrid(bookingNumber: string, mode: 'in' | 'out'): Promise<any | null> {
  try {
    const apiData = await getPage5Data(bookingNumber);
    return apiData;
  } catch (error) {
    console.error('❌ Page 5 API failed:', error);
    return null;
  }
}

/**
 * Save Page 5 data to API (NO localStorage)
 */
export async function savePage5DataHybrid(
  bookingNumber: string,
  data: any,
  mode: 'in' | 'out'
): Promise<{ success: boolean; synced: boolean }> {
  try {
    const result = await savePage5Data(bookingNumber, data);
    return { success: result.success, synced: result.success };
  } catch (error) {
    console.error('❌ Page 5 API save failed:', error);
    return { success: false, synced: false };
  }
}

// =====================================================
// TASKS API - Εργασίες (Work Orders/Tasks)
// =====================================================

const TASKS_API_URL = `${API_BASE}/tasks.php`;

export interface Task {
  id?: number;
  taskCode?: string;
  vesselId: number;
  vesselName?: string;
  title: string;
  description?: string;
  category?: string;
  priority?: 'low' | 'medium' | 'high' | 'urgent';
  status?: 'pending' | 'in_progress' | 'completed' | 'cancelled';
  assignedTo?: string;
  dueDate?: string;
  completedAt?: string;
  completedBy?: string;
  estimatedCost?: number;
  actualCost?: number;
  notes?: string;
  photos?: string[];
  createdBy?: string;
  createdAt?: string;
  updatedAt?: string;
}

/**
 * Get all tasks for a vessel
 */
export async function getTasksByVessel(vesselId: number): Promise<Task[]> {
  try {
    const response = await fetch(`${TASKS_API_URL}?vessel_id=${vesselId}`);
    const result = await response.json();
    if (result.success) {
      console.log(`✅ [API] Loaded ${result.tasks?.length || 0} tasks for vessel ${vesselId}`);
      return result.tasks || [];
    }
    return [];
  } catch (error) {
    console.error(`❌ [API] Failed to fetch tasks for vessel ${vesselId}:`, error);
    return [];
  }
}

/**
 * Get all tasks
 */
export async function getAllTasks(): Promise<Task[]> {
  try {
    const response = await fetch(TASKS_API_URL);
    const result = await response.json();
    if (result.success) {
      console.log(`✅ [API] Loaded ${result.tasks?.length || 0} tasks`);
      return result.tasks || [];
    }
    return [];
  } catch (error) {
    console.error('❌ [API] Failed to fetch tasks:', error);
    return [];
  }
}

/**
 * Save or update a task
 */
export async function saveTask(task: Task): Promise<{ success: boolean; taskCode?: string }> {
  try {
    const method = task.taskCode ? 'PUT' : 'POST';
    const response = await fetch(TASKS_API_URL, {
      method,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(task)
    });
    const result = await response.json();
    if (result.success) {
      console.log(`✅ [API] Task saved:`, result.task_code);
      return { success: true, taskCode: result.task_code };
    }
    // If POST fails with 409, try PUT
    if (response.status === 409) {
      const putResponse = await fetch(TASKS_API_URL, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(task)
      });
      const putResult = await putResponse.json();
      return { success: putResult.success, taskCode: putResult.task_code };
    }
    return { success: false };
  } catch (error) {
    console.error('❌ [API] Failed to save task:', error);
    return { success: false };
  }
}

/**
 * Delete a task
 */
export async function deleteTask(taskCode: string): Promise<boolean> {
  try {
    const response = await fetch(`${TASKS_API_URL}?task_code=${encodeURIComponent(taskCode)}`, {
      method: 'DELETE'
    });
    const result = await response.json();
    return result.success;
  } catch (error) {
    console.error('❌ [API] Failed to delete task:', error);
    return false;
  }
}

/**
 * Migrate tasks from localStorage to API
 * Call this once on app load to preserve existing data
 *
 * IMPORTANT: TaskPage uses `task_categories_${vesselKey}` format
 * where vesselKey is boat name with underscores (e.g., task_categories_bob)
 */
export async function migrateTasksFromLocalStorage(vesselId: number, vesselName: string): Promise<boolean> {
  const migrationKey = `tasks_migrated_${vesselId}`;

  // Check if already migrated
  if (localStorage.getItem(migrationKey)) {
    return true;
  }

  // 🔥 FIX: TaskPage uses vesselName-based key, not vesselId
  const vesselKey = vesselName.replace(/\s+/g, '_').toLowerCase();
  const possibleKeys = [
    `task_categories_${vesselKey}`,           // Primary: task_categories_bob
    `fleet_${vesselId}_ΕΡΓΑΣΙΕΣ`,             // Legacy format 1
    `fleet_${vesselName}_ΕΡΓΑΣΙΕΣ`,           // Legacy format 2
  ];

  let stored: string | null = null;
  let usedKey: string | null = null;

  // Try each possible key
  for (const key of possibleKeys) {
    const data = localStorage.getItem(key);
    if (data) {
      stored = data;
      usedKey = key;
      console.log(`📦 Found task data in localStorage key: ${key}`);
      break;
    }
  }

  if (!stored) {
    // No data to migrate, mark as done
    console.log(`ℹ️ No task data found in localStorage for vessel ${vesselName}`);
    localStorage.setItem(migrationKey, 'true');
    return true;
  }

  try {
    const data = JSON.parse(stored);

    // Handle both array format and categories format
    let tasksToMigrate: any[] = [];

    if (Array.isArray(data)) {
      // Old flat array format
      tasksToMigrate = data;
    } else if (data && typeof data === 'object') {
      // Categories format: extract all items from all categories
      // Format: [{id, name, items: [{id, name, status, comment}]}]
      if (Array.isArray(data)) {
        for (const category of data) {
          if (category.items && Array.isArray(category.items)) {
            for (const item of category.items) {
              tasksToMigrate.push({
                ...item,
                category: category.name,
                categoryId: category.id
              });
            }
          }
        }
      }
    }

    // Also check if data is the categories array directly
    if (tasksToMigrate.length === 0 && Array.isArray(data)) {
      for (const category of data) {
        if (category.items && Array.isArray(category.items)) {
          for (const item of category.items) {
            // Only migrate items that have been updated (have lastUpdatedAt)
            if (item.lastUpdatedAt) {
              tasksToMigrate.push({
                ...item,
                category: category.name,
                categoryId: category.id
              });
            }
          }
        }
      }
    }

    if (tasksToMigrate.length === 0) {
      console.log(`ℹ️ No task items to migrate for vessel ${vesselName}`);
      localStorage.setItem(migrationKey, 'true');
      return true;
    }

    console.log(`🔄 Migrating ${tasksToMigrate.length} tasks for vessel ${vesselName} from ${usedKey}...`);

    for (const task of tasksToMigrate) {
      await saveTask({
        taskCode: task.id || task.taskCode || `task_${Date.now()}_${Math.random().toString(36).slice(2)}`,
        vesselId,
        vesselName,
        title: task.name || task.title,
        category: task.category,
        status: task.status === 'OK' ? 'completed' : task.status === '?' ? 'in_progress' : 'pending',
        notes: task.comment || task.notes,
        createdBy: task.lastUpdatedBy || task.createdBy
      });
    }

    console.log(`✅ Migrated ${tasksToMigrate.length} tasks to API`);
    localStorage.setItem(migrationKey, 'true');
    // Keep localStorage data as backup - don't delete
    return true;
  } catch (error) {
    console.error('❌ Failed to migrate tasks:', error);
    return false;
  }
}

// =====================================================
// INVOICES API - Τιμολόγια/Έξοδα (Invoices/Expenses)
// =====================================================

const INVOICES_API_URL = `${API_BASE}/invoices.php`;

export interface Invoice {
  id?: number;
  invoiceCode?: string;
  vesselId: number;
  vesselName?: string;
  invoiceNumber?: string;
  invoiceType?: 'expense' | 'income' | 'credit';
  category?: string;
  description?: string;
  vendor?: string;
  amount: number;
  vatAmount?: number;
  totalAmount?: number;
  currency?: string;
  invoiceDate?: string;
  dueDate?: string;
  paidDate?: string;
  paymentStatus?: 'pending' | 'paid' | 'overdue' | 'cancelled';
  paymentMethod?: string;
  referenceNumber?: string;
  charterCode?: string;
  notes?: string;
  attachments?: string[];
  createdBy?: string;
  createdAt?: string;
  updatedAt?: string;
}

/**
 * Get all invoices for a vessel
 */
export async function getInvoicesByVessel(vesselId: number): Promise<Invoice[]> {
  try {
    const response = await fetch(`${INVOICES_API_URL}?vessel_id=${vesselId}`);
    const result = await response.json();
    if (result.success) {
      console.log(`✅ [API] Loaded ${result.invoices?.length || 0} invoices for vessel ${vesselId}`);
      return result.invoices || [];
    }
    return [];
  } catch (error) {
    console.error(`❌ [API] Failed to fetch invoices for vessel ${vesselId}:`, error);
    return [];
  }
}

/**
 * Get all invoices
 */
export async function getAllInvoices(): Promise<Invoice[]> {
  try {
    const response = await fetch(INVOICES_API_URL);
    const result = await response.json();
    if (result.success) {
      console.log(`✅ [API] Loaded ${result.invoices?.length || 0} invoices`);
      return result.invoices || [];
    }
    return [];
  } catch (error) {
    console.error('❌ [API] Failed to fetch invoices:', error);
    return [];
  }
}

/**
 * Save or update an invoice
 */
export async function saveInvoice(invoice: Invoice): Promise<{ success: boolean; invoiceCode?: string }> {
  try {
    const method = invoice.invoiceCode ? 'PUT' : 'POST';
    const response = await fetch(INVOICES_API_URL, {
      method,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(invoice)
    });
    const result = await response.json();
    if (result.success) {
      console.log(`✅ [API] Invoice saved:`, result.invoice_code);
      return { success: true, invoiceCode: result.invoice_code };
    }
    // If POST fails with 409, try PUT
    if (response.status === 409) {
      const putResponse = await fetch(INVOICES_API_URL, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(invoice)
      });
      const putResult = await putResponse.json();
      return { success: putResult.success, invoiceCode: putResult.invoice_code };
    }
    return { success: false };
  } catch (error) {
    console.error('❌ [API] Failed to save invoice:', error);
    return { success: false };
  }
}

/**
 * Delete an invoice
 */
export async function deleteInvoice(invoiceCode: string): Promise<boolean> {
  try {
    const response = await fetch(`${INVOICES_API_URL}?invoice_code=${encodeURIComponent(invoiceCode)}`, {
      method: 'DELETE'
    });
    const result = await response.json();
    return result.success;
  } catch (error) {
    console.error('❌ [API] Failed to delete invoice:', error);
    return false;
  }
}

/**
 * Migrate invoices from localStorage to API
 * Call this once on app load to preserve existing data
 */
export async function migrateInvoicesFromLocalStorage(vesselId: number, vesselName: string): Promise<boolean> {
  const migrationKey = `invoices_migrated_${vesselId}`;

  // Check if already migrated
  if (localStorage.getItem(migrationKey)) {
    return true;
  }

  const storageKey = `fleet_${vesselId}_ΤΙΜΟΛΟΓΙΑ`;
  const stored = localStorage.getItem(storageKey);

  if (!stored) {
    // No data to migrate, mark as done
    localStorage.setItem(migrationKey, 'true');
    return true;
  }

  try {
    const invoices = JSON.parse(stored);
    if (!Array.isArray(invoices) || invoices.length === 0) {
      localStorage.setItem(migrationKey, 'true');
      return true;
    }

    console.log(`🔄 Migrating ${invoices.length} invoices for vessel ${vesselName}...`);

    for (const invoice of invoices) {
      await saveInvoice({
        ...invoice,
        vesselId,
        vesselName,
        invoiceCode: invoice.id || invoice.invoiceCode
      });
    }

    console.log(`✅ Migrated ${invoices.length} invoices to API`);
    localStorage.setItem(migrationKey, 'true');
    // Optionally clear old localStorage after successful migration
    // localStorage.removeItem(storageKey);
    return true;
  } catch (error) {
    console.error('❌ Failed to migrate invoices:', error);
    return false;
  }
}

// =====================================================
// VESSELS API - TYPED VERSION
// =====================================================

export interface Vessel {
  id?: number;
  name: string;
  type: string;
  model: string;
  length?: number;
  capacity?: number;
  year?: number;
  created_at?: string;
}

export const getVessel = async (id: number): Promise<Vessel | null> => {
  try {
    const response = await fetch(`${API_URL}/vessels.php?id=${id}`);
    const data = await response.json();
    return data.success ? data.vessel : null;
  } catch (error) {
    console.error('Error fetching vessel:', error);
    return null;
  }
};

// =====================================================
// FLOOR PLAN API
// =====================================================

export interface Hotspot {
  id: string;
  x: number;
  y: number;
  label: string;
  type: string;
  category: string;
}

export interface Floorplan {
  id?: number;
  vessel_id: number;
  background_image: string;
  hotspots: Hotspot[];
  created_at?: string;
  updated_at?: string;
}

export const getFloorplan = async (vesselId: number, pageGroup: string = 'page2'): Promise<Floorplan | null> => {
  try {
    const response = await fetch(`${API_URL}/floorplans.php?vessel_id=${vesselId}&page_group=${encodeURIComponent(pageGroup)}`, {
      headers: authHeaders(),
    });
    const data = await response.json();
    return data.success ? data.floorplan : null;
  } catch (error) {
    console.error('Error fetching floorplan:', error);
    return null;
  }
};

export const saveFloorplan = async (floorplan: { vessel_id: number; page_group?: string; background_image: string; hotspots: Hotspot[] }, employeeCode?: string): Promise<boolean> => {
  try {
    const response = await fetch(`${API_URL}/floorplans.php`, {
      method: 'POST',
      headers: employeeCode
        ? { ...authHeaders(), 'Content-Type': 'application/json', 'X-Employee-Code': employeeCode }
        : { ...authHeaders(), 'Content-Type': 'application/json' },
      body: JSON.stringify({ page_group: 'page2', ...floorplan }),
    });
    const data = await response.json();
    return data.success;
  } catch (error) {
    console.error('Error saving floorplan:', error);
    return false;
  }
};

export const deleteFloorplan = async (vesselId: number, pageGroup: string = 'page2'): Promise<boolean> => {
  try {
    const response = await fetch(`${API_URL}/floorplans.php?vessel_id=${vesselId}&page_group=${encodeURIComponent(pageGroup)}`, {
      method: 'DELETE',
      headers: authHeaders(),
    });
    const data = await response.json();
    return data.success;
  } catch (error) {
    console.error('Error deleting floorplan:', error);
    return false;
  }
};

// Fuzzy search booking by numeric code (tolerant of CHARTER PARTY / NO / typos)
export async function searchBookingByCode(code: string): Promise<{ booking_number: string; booking_data: any } | null> {
  if (!code) return null;
  try {
    const res = await fetch(`${API_BASE}/bookings.php?action=search_by_code&code=${encodeURIComponent(code)}`);
    if (!res.ok) return null;
    const json = await res.json();
    return json?.booking || null;
  } catch (e) {
    return null;
  }
}

// ΑΠΥ (Receipts) Functions
export const getReceiptsByVessel = async (vesselId: number): Promise<any> => {
  const response = await fetch(`${API_BASE}/receipts.php?company_id=${getCompanyId()}&vessel_id=${vesselId}`);
  return response.json();
};

export const getAllReceipts = async (): Promise<any> => {
  const response = await fetch(`${API_BASE}/receipts.php?company_id=${getCompanyId()}`);
  return response.json();
};

export const saveReceipt = async (receipt: any): Promise<any> => {
  const response = await fetch(`${API_BASE}/receipts.php?company_id=${getCompanyId()}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(receipt)
  });
  return response.json();
};

export const updateReceipt = async (receiptId: number, receipt: any): Promise<any> => {
  const response = await fetch(`${API_BASE}/receipts.php?company_id=${getCompanyId()}&id=${receiptId}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(receipt)
  });
  return response.json();
};

export const deleteReceipt = async (receiptId: number): Promise<boolean> => {
  try {
    const response = await fetch(`${API_BASE}/receipts.php?company_id=${getCompanyId()}&id=${receiptId}`, {
      method: 'DELETE'
    });
    const data = await response.json();
    return data.success;
  } catch (error) {
    console.error('Error deleting receipt:', error);
    return false;
  }
};

// ==========================================================================
// ROUTINE CHECK TEMPLATE — manage template items (add/remove from DB)
// ==========================================================================

export const getRoutineCheckTemplate = async () => {
  try {
    const response = await fetch(`${API_BASE}/routine-check-template.php`);
    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    const data = await response.json();
    return data.items || [];
  } catch (error) {
    console.error('Error fetching template items:', error);
    return [];
  }
};

export const addRoutineCheckTemplateItem = async (payload: {
  category: string;
  item_key: string;
  item_label_gr: string;
  item_label_en: string;
}) => {
  try {
    const response = await fetch(`${API_BASE}/routine-check-template.php`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });
    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    const data = await response.json();
    return data.item || null;
  } catch (error) {
    console.error('Error adding template item:', error);
    return null;
  }
};

export const deleteRoutineCheckTemplateItem = async (id: number) => {
  try {
    const response = await fetch(`${API_BASE}/routine-check-template.php?id=${id}`, {
      method: 'DELETE',
    });
    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    const data = await response.json();
    return data.ok === true;
  } catch (error) {
    console.error('Error deleting template item:', error);
    return false;
  }
};

// =====================================================
// PAGE 5 AGREEMENT API (added 01May2026)
// =====================================================

/**
 * Get page 5 agreement records (check-in and check-out) for a booking
 */
export async function getPage5Agreement(bookingNumber: string) {
  const url = `${API_URL}/page5-agreement.php?booking_number=${encodeURIComponent(bookingNumber)}`;
  const response = await fetch(url, { cache: 'no-store' });
  if (!response.ok) throw new Error('Failed to fetch page5 agreement');
  const json = await response.json();
  // Returns { checkIn: {...} | null, checkOut: {...} | null }
  return json?.data || { checkIn: null, checkOut: null };
}

/**
 * Save (upsert) page 5 agreement record for a booking + mode
 * mode: 'in' or 'out'
 */
export async function savePage5Agreement(
  bookingNumber: string,
  mode: 'in' | 'out',
  payload: {
    terms_accepted?: boolean;
    skipper_signature?: string | null;
    company_signature?: string | null;
    company_representative?: string | null;
    email_sent?: boolean;
    email_sent_at?: string | null;
    notes?: string | null;
    items_snapshot?: any | null;
  } = {}
) {
  const body = {
    booking_number: bookingNumber,
    mode,
    ...payload,
  };
  const response = await fetch(`${API_URL}/page5-agreement.php`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
    cache: 'no-store',
  });
  if (!response.ok) throw new Error('Failed to save page5 agreement');
  return response.json();
}


// ============================================================================
// === PHASE 4: MASTER ITEMS ADMIN + YACHT ITEMS ADMIN + AI TRANSLATION ========
// ============================================================================

function authHeaders(): Record<string, string> {
  const code = authService.getCurrentUser()?.code || '';
  return {
    'Content-Type': 'application/json',
    'X-Employee-Code': code,
  };
}

async function parseOrThrow(response: Response, fallback: string) {
  let json: any = null;
  try { json = await response.json(); } catch (_) { /* ignore */ }
  if (!response.ok) {
    const msg = (json && (json.error || json.message)) || fallback;
    const err: any = new Error(msg);
    err.status = response.status;
    err.body = json;
    throw err;
  }
  return json;
}

// === MASTER SECTIONS ===

export async function getMasterSections(pageGroup?: string) {
  const params = new URLSearchParams();
  if (pageGroup) params.set('page_group', pageGroup);
  const qs = params.toString();
  const url = `${API_URL}/master-sections.php${qs ? '?' + qs : ''}`;
  const response = await fetch(url, { cache: 'no-store' });
  const json = await parseOrThrow(response, 'Failed to fetch master sections');
  return json?.sections || [];
}

// === MASTER ITEMS ===

export async function getMasterItems(section?: string, pageGroup?: string) {
  const params = new URLSearchParams();
  if (section) params.set('section', section);
  if (pageGroup) params.set('page_group', pageGroup);
  const qs = params.toString();
  const url = `${API_URL}/master-items.php${qs ? '?' + qs : ''}`;
  const response = await fetch(url, { cache: 'no-store' });
  const json = await parseOrThrow(response, 'Failed to fetch master items');
  return json?.items || [];
}

export async function createMasterItem(data: {
  section: string;
  item_key: string;
  label_el: string;
  label_en: string;
  label_it?: string;
  label_de?: string;
  label_ru?: string;
  label_fr?: string;
  label_ro?: string;
  label_pl?: string;
  label_he?: string;
  label_es?: string;
  sort_order?: number;
  active?: boolean;
}, employeeCode?: string) {
  const response = await fetch(`${API_URL}/master-items.php`, {
    method: 'POST',
    headers: employeeCode ? { ...authHeaders(), 'X-Employee-Code': employeeCode } : authHeaders(),
    body: JSON.stringify(data),
    cache: 'no-store',
  });
  return parseOrThrow(response, 'Failed to create master item');
}

export async function updateMasterItem(
  id: number,
  data: Partial<{
    section: string;
    item_key: string;
    page_group: string;
    label_el: string;
    label_en: string;
    label_it: string;
    label_de: string;
    label_ru: string;
    label_fr: string;
    label_ro: string;
    label_pl: string;
    label_he: string;
    label_es: string;
    sort_order: number;
    active: boolean;
  }>,
  employeeCode?: string
) {
  const response = await fetch(`${API_URL}/master-items.php?id=${encodeURIComponent(String(id))}`, {
    method: 'PUT',
    headers: employeeCode ? { ...authHeaders(), 'X-Employee-Code': employeeCode } : authHeaders(),
    body: JSON.stringify(data),
    cache: 'no-store',
  });
  return parseOrThrow(response, 'Failed to update master item');
}

export async function deleteMasterItem(id: number, employeeCode?: string) {
  const response = await fetch(`${API_URL}/master-items.php?id=${encodeURIComponent(String(id))}`, {
    method: 'DELETE',
    headers: employeeCode ? { ...authHeaders(), 'X-Employee-Code': employeeCode } : authHeaders(),
    cache: 'no-store',
  });
  return parseOrThrow(response, 'Failed to delete master item');
}

// === YACHT ITEMS ===

export async function getYachtItems(vesselId: number, section?: string, includeInactive?: boolean) {
  const params = new URLSearchParams();
  params.set('vessel_id', String(vesselId));
  if (section) params.set('section', section);
  if (includeInactive) params.set('include_inactive', 'true');
  const url = `${API_URL}/yacht-items.php?${params.toString()}`;
  const response = await fetch(url, { cache: 'no-store' });
  const json = await parseOrThrow(response, 'Failed to fetch yacht items');
  return json?.items || [];
}

export async function bulkUpdateYachtItems(
  updates: Array<{
    id: number;
    qty?: number;
    price?: number | string;
    active?: boolean;
    notes?: string | null;
  }>,
  employeeCode?: string
) {
  const response = await fetch(`${API_URL}/yacht-items.php?action=bulk_update`, {
    method: 'POST',
    headers: employeeCode ? { ...authHeaders(), 'X-Employee-Code': employeeCode } : authHeaders(),
    body: JSON.stringify({ updates }),
    cache: 'no-store',
  });
  return parseOrThrow(response, 'Failed to bulk-update yacht items');
}

export async function createYachtItem(data: {
  vessel_id: number;
  item_key: string;
  section: string;
  qty?: number;
  price?: number | string;
  active?: boolean;
  notes?: string | null;
}) {
  const response = await fetch(`${API_URL}/yacht-items.php`, {
    method: 'POST',
    headers: authHeaders(),
    body: JSON.stringify(data),
    cache: 'no-store',
  });
  return parseOrThrow(response, 'Failed to create yacht item');
}

export async function deleteYachtItem(id: number) {
  const response = await fetch(`${API_URL}/yacht-items.php?id=${encodeURIComponent(String(id))}`, {
    method: 'DELETE',
    headers: authHeaders(),
    cache: 'no-store',
  });
  return parseOrThrow(response, 'Failed to delete yacht item');
}

// === AI TRANSLATION ===

export async function translateItemToAllLanguages(
  el: string,
  en: string = ''
): Promise<{ el: string; en: string; it: string; de: string; ru: string; fr: string; ro: string; pl: string; he: string; es: string }> {
  const response = await fetch(`${API_URL}/translate-item.php`, {
    method: 'POST',
    headers: authHeaders(),
    body: JSON.stringify({ el, en }),
    cache: 'no-store',
  });

  let json: any = null;
  try { json = await response.json(); } catch (_) { /* ignore */ }

  if (response.status === 503 && json && json.configured === false) {
    const err: any = new Error('AI_TRANSLATION_NOT_CONFIGURED');
    err.code = 'AI_TRANSLATION_NOT_CONFIGURED';
    err.status = 503;
    throw err;
  }

  if (!response.ok) {
    const msg = (json && (json.error || json.message)) || 'Failed to translate item';
    const err: any = new Error(msg);
    err.status = response.status;
    err.body = json;
    throw err;
  }

  if (!json || !json.success || !json.translations) {
    throw new Error('Translation response invalid');
  }
  return json.translations;
}

// === MASTER SECTIONS — CREATE / UPDATE ===

export async function createMasterSection(data: {
  section_key: string;
  page_group: string;
  title_el: string;
  title_en: string;
  title_it?: string;
  title_de?: string;
  title_ru?: string;
  title_fr?: string;
  title_ro?: string;
  title_pl?: string;
  title_he?: string;
  title_es?: string;
  sort_order?: number;
}, employeeCode?: string) {
  const response = await fetch(`${API_URL}/master-sections.php`, {
    method: 'POST',
    headers: employeeCode ? { ...authHeaders(), 'X-Employee-Code': employeeCode } : authHeaders(),
    body: JSON.stringify(data),
    cache: 'no-store',
  });
  return parseOrThrow(response, 'Failed to create master section');
}

export async function updateMasterSection(
  id: number,
  data: Partial<{
    title_el: string;
    title_en: string;
    title_it: string;
    title_de: string;
    title_ru: string;
    title_fr: string;
    title_ro: string;
    title_pl: string;
    title_he: string;
    title_es: string;
    sort_order: number;
    active: boolean;
  }>,
  employeeCode?: string
) {
  const response = await fetch(`${API_URL}/master-sections.php?id=${encodeURIComponent(String(id))}`, {
    method: 'PUT',
    headers: employeeCode ? { ...authHeaders(), 'X-Employee-Code': employeeCode } : authHeaders(),
    body: JSON.stringify(data),
    cache: 'no-store',
  });
  return parseOrThrow(response, 'Failed to update master section');
}
